
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrlFromEnv } from "utils/environment.util";
import { ActivityFromCollectionModel, type activityType, type ApiActivityFromCollectionType } from 'models/activity.model';
import type { sectionDataType } from 'components/scrollableSection/scrollableSection';

export const collectionsApi = createApi({
  reducerPath: 'collectionsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${getApiUrlFromEnv(process.env.REACT_APP_ENV_VAR ?? "")}/api`,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set("Content-Type", "application/json");
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({

    getCollections: builder.query<{ [k: string]: sectionDataType }, void>({
      queryFn: async (_arg, _api, _extraOptions, fetchWithBQ) => {
        const res = await fetchWithBQ('/collections/authorized');
        if (res.error) return { error: res.error };

        const collections = await res.data as any[];

        collections.sort((a, b) => a.name.localeCompare(b.name));

        const formattedCollections: { [k: string]: sectionDataType } = {};
        collections.forEach((c) => {
          formattedCollections[c.id] = {
            sectionId: c.id,
            sectionName: c.name,
            activities: [],
            isSeeMore: false,
            isScrollable: false,
            isLoading: true,
            img: c.slide_images[0],
            description: c.description,
          };
        });

        return { data: formattedCollections };
      },
    }),

    getActivitiesByCollection: builder.query<{resources: activityType[], count: number}, { collectionId?: string; keywords?: string, scopeCollections?: string[], limit: number, offset: number }>({
      query: ({ collectionId, keywords, scopeCollections, limit, offset }) => ({
        url: '/resources/search',
        method: 'POST',
        body: {
          skip: offset,
          limit,
          keywords: keywords ?? "",
          sort_by: "TITLE_ASC",
          search_type: "ALL",
          scope_collections: scopeCollections ?? [],
          collection: collectionId,
        },
      }),
      transformResponse: (res: any) => {
        const result = {resources:[], count: res.count}
        result.resources = res.results.map((r: { score: number, document: ApiActivityFromCollectionType }) => new ActivityFromCollectionModel(r.document));

        return result;
      }
    }),
  }),
});

export const {
  useGetCollectionsQuery,
  useGetActivitiesByCollectionQuery,
} = collectionsApi;
